module.exports = __webpack_public_path__ + "static/media/posteitalia.b758ca11.svg";